import * as types from '../types/product';
import {List} from 'immutable';

export default function Product(state = {
  categories: [],
  types: [],
  list: [],
  pizzas: [],
  pizzaSauces: [],
  pizzaCategories: [],
  filterCategory: null,
  filterType: null,
  item: null,
  ingredients: List()
}, action) {
  switch (action.type) {
    case types.PRODUCT_FETCHED:
      return {
        ...state,
        list: action.data
      };
    case types.PRODUCT_CATEGORY_FETCHED:
      return {
        ...state,
        categories: action.data
      };
    case types.PRODUCT_CATEGORY_FILTER:
      return {
        ...state,
        filterCategory: action.data
      };
    case types.PRODUCT_TYPE_FETCHED:
      return {
        ...state,
        types: action.data.sort((a, b) => {
          return a.position - b.position;
        })
      };
    case types.PRODUCT_TYPE_FILTER:
      return {
        ...state,
        filterType: action.data
      };
    case types.PIZZA_FETCHED:
      return {
        ...state,
        pizzas: action.data
      };
    case types.PIZZA_SAUCE_FETCHED:
      return {
        ...state,
        pizzaSauces: action.data
      };
    case types.PIZZA_CATEGORY_FETCHED:
      return {
        ...state,
        pizzaCategories: action.data
      };
    case types.INGREDIENT_FETCHED:
      return {
        ...state,
        ingredients: action.data
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/product.js